import { render, staticRenderFns } from "./TextWithLeftPicture.vue?vue&type=template&id=4f63725c&"
import script from "./TextWithLeftPicture.vue?vue&type=script&lang=js&"
export * from "./TextWithLeftPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports